function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../_snowpack/pkg/react.js';
const BORDER_COLORS = {
  colored: '#528693',
  accent: '#ffccec',
  muted: '#828a90'
};
const PRIMARY_COLORS = {
  colored: '#bff6f8',
  accent: '#ffccec',
  muted: '#fff'
};
const SvgComponent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    variant = 'colored',
    height = 34,
    width = 34,
    ...rest
  } = props;
  const borderColor = BORDER_COLORS[variant];
  const primaryColor = PRIMARY_COLORS[variant];
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: width,
    height: height,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M6.61561 5.18342H25.0671H27.0366L28.0213 8.13757L29.006 15.0306L6.35752 13.0612L5.3728 7.15285L6.61561 5.18342Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35752 13.0611H19.1588H28.0213L29.006 17L28.0213 26.8472L27.0366 28.8166H14.2353H7.34224H6.35752L5.3728 26.8472L6.35752 22.9083V17V13.0611Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69756 4.39563H25.3681C26.716 4.39563 27.8662 5.37006 28.0878 6.69955L28.326 8.12863C29.305 14.0024 29.305 19.9976 28.326 25.8714L28.0878 27.3005C27.8662 28.6299 26.716 29.6044 25.3681 29.6044H7.69756C5.99377 29.6044 4.69776 28.0745 4.97786 26.3939L5.10812 25.6124C6.05849 19.9101 6.05849 14.0899 5.10812 8.38765L4.97786 7.60612C4.69776 5.92551 5.99377 4.39563 7.69756 4.39563ZM7.69756 5.27456C6.48057 5.27456 5.73939 6.14667 5.93946 7.3471L6.06972 8.12863C7.03438 13.9166 7.03438 19.8244 6.06972 25.6124L5.93946 26.3939C5.73939 27.5943 6.48056 28.641 7.69756 28.641H25.3681C26.3309 28.641 27.0227 28.1206 27.181 27.1709L27.4192 25.7419C28.3838 19.9539 28.3838 14.0461 27.4192 8.25814L27.181 6.82906C27.0227 5.87943 26.3309 5.27456 25.3681 5.27456H7.69756Z",
    fill: borderColor
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4567 13.455L6.24786 13.455L6.24786 12.4094L28.4567 12.4094L28.4567 13.455Z",
    fill: borderColor
  }));
});
export default SvgComponent;